module.exports = __webpack_public_path__ + "img/Modernisme_Tida_og_samfunnsforholdene4.da5c80f7.jpg";